module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.a8d6ac0.ttf";